import statusLabel from './statusLabel'
import statusColor from './statusColor'

const questionnaires = {
  statusLabel,
  statusColor,
}

export default questionnaires
